import { OktellRepository } from '@/core/repositories/oktell.repository'
import {
    CreateCallBackPayload,
    GetBoxTemplatesParams,
    GetBoxTemplatesResponse,
    GetDeliveryTypesResponse,
    GetWarehouseParams,
    GetWarehouseResponse,
    OktellClientDraftPayload,
    OktellClientPayload,
    OktellCreateWaitListParams,
    OktellDeclineCallPayload,
    OktellEstimatePayload,
    OktellEstimateResponse,
    OktellGetActivityTypesResponse,
    OktellGetCargoVolumesResponse,
    OktellGetCitiesParams,
    OktellGetCitiesResponse,
    OktellGetClientResponse,
    OktellGetCommunicationsParams,
    OktellGetCommunicationsResponse,
    OktellGetCompaniesResponse,
    OktellGetDeclineReasonsResponse,
    OktellGetDirectionTypesResponse,
    OktellGetInvoicesParams,
    OktellGetInvoicesResponse,
    OktellGetReasonsResponse,
    OktellGetWaitListParams,
    OktellGetWaitListResponse,
    OktellGetWhatsappHistoryParams,
    OktellGetWhatsappHistoryResponse,
    OktellGetWhatsappTokenResponse,
    OktellIsHaveWhatsappResponse,
    OktellMultiorderPayload,
    OktellRandomCallPayload,
    OtkellGetInvoiceStatusesResponse,
} from '@/core/types/oktell.types'

const oktellRepository = new OktellRepository()

export class OktellService {
    async getClientByPhone(phone: string): Promise<OktellGetClientResponse> {
        const response = await oktellRepository.getClientByPhone(phone)
        return response.data
    }

    async createClient(payload: OktellClientPayload): Promise<void> {
        const response = await oktellRepository.createClient(payload)
        return response.data
    }

    async getInvoices(params: OktellGetInvoicesParams): Promise<OktellGetInvoicesResponse> {
        const response = await oktellRepository.getInvoices(params)
        return response.data
    }

    async getWaitList(params: OktellGetWaitListParams): Promise<OktellGetWaitListResponse> {
        const response = await oktellRepository.getWaitList(params)
        return response.data
    }

    async createWaitList(payload: OktellCreateWaitListParams): Promise<void> {
        const response = await oktellRepository.createWaitList(payload)
        return response.data
    }

    async createWaitListMass(payload: OktellCreateWaitListParams): Promise<void> {
        const response = await oktellRepository.createWaitListMass(payload)
        return response.data
    }

    async getInvoiceStatuses(): Promise<OtkellGetInvoiceStatusesResponse> {
        const response = await oktellRepository.getInvoiceStatuses()
        return response.data
    }

    async getCommunications(
        params: OktellGetCommunicationsParams
    ): Promise<OktellGetCommunicationsResponse> {
        const response = await oktellRepository.getCommunications(params)
        return response.data
    }

    async getCities(params: OktellGetCitiesParams): Promise<OktellGetCitiesResponse> {
        const response = await oktellRepository.getCities(params)
        return response.data
    }

    async getWhatsappToken(): Promise<OktellGetWhatsappTokenResponse> {
        const response = await oktellRepository.getWhatsappToken()
        return response.data
    }

    async isHaveWhatsapp(phone: string): Promise<OktellIsHaveWhatsappResponse> {
        const response = await oktellRepository.isHaveWhatsapp(phone)
        return response.data
    }

    async sendWhatsappMessage(form_data: FormData): Promise<void> {
        const response = await oktellRepository.sendWhatsappMessage(form_data)
        return response.data
    }

    async getWhatsappHistory(
        params: OktellGetWhatsappHistoryParams
    ): Promise<OktellGetWhatsappHistoryResponse> {
        const response = await oktellRepository.getWhatsappHistory(params)
        return response.data
    }

    async getBoxTemplates(params: GetBoxTemplatesParams): Promise<GetBoxTemplatesResponse> {
        const response = await oktellRepository.getBoxTemplates(params)
        return response.data
    }

    async getDeliveryTypes(): Promise<GetDeliveryTypesResponse> {
        const response = await oktellRepository.getDeliveryTypes()
        return response.data
    }

    async getSenderWarehouse(params: GetWarehouseParams): Promise<GetWarehouseResponse> {
        const response = await oktellRepository.getSenderWarehouse(params)
        return response.data
    }

    async getReceiverWarehouse(params: GetWarehouseParams): Promise<GetWarehouseResponse> {
        const response = await oktellRepository.getReceiverWarehouse(params)
        return response.data
    }

    async estimate(payload: OktellEstimatePayload): Promise<OktellEstimateResponse> {
        const response = await oktellRepository.estimate(payload)
        return response.data
    }

    async createMultiorder(payload: OktellMultiorderPayload): Promise<void> {
        const response = await oktellRepository.createMultiorder(payload)
        return response.data
    }

    async clientDraft(payload: OktellClientDraftPayload): Promise<void> {
        const response = await oktellRepository.clientDraft(payload)
        return response.data
    }

    async randomCall(payload: OktellRandomCallPayload): Promise<void> {
        const response = await oktellRepository.randomCall(payload)
        return response.data
    }

    async createCallBack(payload: CreateCallBackPayload): Promise<void> {
        const response = await oktellRepository.createCallBack(payload)
        return response.data
    }

    async getReasons(): Promise<OktellGetReasonsResponse> {
        const response = await oktellRepository.getReasons()
        return response.data
    }

    async dialogCardNext(): Promise<void> {
        const response = await oktellRepository.dialogCardNext()
        return response.data
    }

    async getCompanyName(id: number): Promise<OktellGetCompaniesResponse> {
        const response = await oktellRepository.getCompanyName(id)
        return response.data
    }

    async getActivityTypes(): Promise<OktellGetActivityTypesResponse> {
        const response = await oktellRepository.getActivityTypes()
        return response.data
    }

    async getCargoVolumes(): Promise<OktellGetCargoVolumesResponse> {
        const response = await oktellRepository.getCargoVolumes()
        return response.data
    }

    async getDirectionTypes(): Promise<OktellGetDirectionTypesResponse> {
        const response = await oktellRepository.getDirectionTypes()
        return response.data
    }

    async getDeclineReasons(): Promise<OktellGetDeclineReasonsResponse> {
        const response = await oktellRepository.getDeclineReasons()
        return response.data
    }

    async declineCall(payload: OktellDeclineCallPayload): Promise<void> {
        const response = await oktellRepository.declineCall(payload)
        return response.data
    }
}
